export default __webpack_public_path__ + "static/media/getFetch.7b8d3172.cjs";